import type { ReactNode } from 'react';
import { LANG_DIR, UI, type Lang } from '@ringring/core';
import { LangPicker, Logo } from './lang';
import { Icon } from './Icon';

/** Shared entrance for owners and the counter team. The ticket is an explicitly labelled illustration. */
export function AuthLayout({ lang, setLang, children }: { lang: Lang; setLang: (l: Lang) => void; children: ReactNode }) {
  const t = UI[lang];
  return (
    <div className="app auth-layout" lang={lang} dir={LANG_DIR[lang]}>
      <aside className="auth-story">
        <a href="#/" className="auth-brand">
          <Logo reverse />
        </a>
        <div className="auth-story-copy">
          <p className="eyebrow">
            <span className="signal-dot" />
            {t.design_restaurant_space}
          </p>
          <h2>
            {t.design_auth_heading}
            <span>{t.design_auth_accent}</span>
          </h2>
          <p className="auth-description">{t.design_auth_body}</p>
        </div>
        <div className="ticket-scene">
          <span className="scene-orbit orbit-one" aria-hidden="true" />
          <span className="scene-orbit orbit-two" aria-hidden="true" />
          <div className="sample-ticket">
            <div className="sample-top">
              <Icon name="orders" />
              <span className="eyebrow">{t.design_preview}</span>
            </div>
            <p>{t.your_number}</p>
            <bdi dir="ltr" className="sample-number">
              042
            </bdi>
            <div className="sample-status">
              <Icon name="check" />
              {t.order_ready}
            </div>
            <div className="sample-tear" />
            <div className="sample-pickup">
              <Icon name="location" />
              {t.tv_sub}
            </div>
          </div>
          <span className="scene-bell" aria-hidden="true">
            <Icon name="bell" />
          </span>
        </div>
        <p className="auth-story-footer">{t.design_auth_footer}</p>
      </aside>
      <div className="auth-main">
        <header className="topbar auth-topbar">
          <a className="mobile-brand" href="#/">
            <Logo />
          </a>
          <LangPicker lang={lang} setLang={setLang} />
        </header>
        <main className="auth-content">{children}</main>
        <footer className="auth-footer">
          <Icon name="lock" />
          {t.design_secure_access}
        </footer>
      </div>
    </div>
  );
}
